import script from "./VentasPeriodoChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./VentasPeriodoChart.vue?vue&type=script&setup=true&lang=ts"

import "./VentasPeriodoChart.vue?vue&type=style&index=0&id=46a29a52&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a29a52"]])

export default __exports__